import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IModeratorCreate, IModerator, IModeratorUpdate } from '@tsin-core/states/moderator/moderator.models';
import { environment } from '@tsin-env/environment';
import { map, Observable } from 'rxjs';

const MODERATOR_URL = `${environment.externalApiUrl}/user`;
const MODERATOR_ASSIGNMENT_URL = `${environment.apiUrl}/administration/assign-moderators`;
const MODERATOR_URL_2 = `${environment.apiUrl2}`;
const WWUS_POOL_URL = `${environment.apiUrl}/supervisors/wwus-pool`;

@Injectable({
  providedIn: 'root'
})

export class ModeratorService {

  private http = inject(HttpClient);

  // POST: Create a new moderator
  createModerator(interviewer: IModeratorCreate): Observable<IModerator> {
    return this.http.post<IModerator>(MODERATOR_URL, interviewer);
  }

  // PUT: Update an existing moderator
  updateModerator(interviewer: IModeratorUpdate): Observable<IModerator> {
    return this.http.put<IModerator>(`${MODERATOR_URL}`, interviewer);
  }

  // GET: Fetch all moderators via PRO-Backend (proxied from WWUS)
  getModerators(): Observable<IModerator[]> {
    return this.http
      .get<{ data: IModerator[]; count: number }>(
        `${WWUS_POOL_URL}?role=proModerator`,
      )
      .pipe(
        map((response) => response.data || []),
      );
  }

  // POST: Upload file or additional data related to moderator
  uploadModeratorData(data: any, id: string): Observable<any> {
    return this.http.post(`${MODERATOR_URL}/upload`, data);
  }

  // GET: Fetch a single moderator by ID
  getModerator(id: string): Observable<IModerator> {
    return this.http.get<IModerator>(`${MODERATOR_URL}/single/${id}`);
  }


  // DELETE: Delete a moderator by ID
  deleteModerator(id: string): Observable<any> {
    return this.http.delete(`${MODERATOR_URL}/single/${id}`);
  }
}
